import React from 'react';

const ScoreTarget = () => {
  return (
    <div className="flex items-center text-gray-700">
      <label className="w-24 mr-5 font-bold ">対象スコア</label>
      <div className="flex items-center">
        <span>A</span>
      </div>
    </div>
  );
};
export default ScoreTarget;
